export function timeSinceOtpSentInSeconds(otpSent: Date) : number {
  return Math.floor(((new Date()).getTime() - otpSent.getTime()) / 1000);
}